<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-expansion-panel expand class="grey lighten-3">
          <v-expansion-panel-content v-model="panel" class="grey lighten-4">
            <div
              slot="header"
              class="font-weight-medium grey--text text--darken-2 vertical-center-container"
            >
              <v-icon
                :color="color"
                class="mr-2"
              >{{this.$store.state.global.pages[this.route].icon}}</v-icon>
              {{title}}
            </div>

            <v-list subheader>
              <v-list-tile v-for="item in items" :key="item.id" fluid>
                <v-checkbox
                  v-model="selectedValues"
                  :label="item.name"
                  :value="item.id"
                  :color="color"
                ></v-checkbox>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-checkbox v-model="selectAllValues" :color="color">
                  <div slot="label" class="font-weight-bold">Select All</div>
                </v-checkbox>
              </v-list-tile>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    items: Array,
    title: String,
    route: String,
    value: Array
  },
  data() {
    return {
      panel: false,
      selectedValues: [],
      selectAllValues: false,
      color: this.$store.state.global.pages[this.route].color
    };
  },
  computed: {
    allValues() {
      return this.items.map(item => {
        return item.id;
      });
    }
  },
  watch: {
    selectAllValues(val) {
      val ? (this.selectedValues = this.allValues) : (this.selectedValues = []);
    },
    selectedValues(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.selectedValues = val;
      // if (!val.length) {
      //     this.selectedValues = [];
      // }
    }
  }
};
</script>

<style>
</style>
